import { useSearchParams } from 'react-router';
import { useI18n } from '../i18n.js';
import { safeVerifyLink } from '../oauth.js';

/**
 * Magic links land here first: mail scanners open links before people do, and a link works once, so the sign-in
 * happens only when the person presses the button.
 */
export function Confirm() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const link = safeVerifyLink(params.get('link'), window.location.origin);
  return (
    <div className="stack">
      <h2 className="bare-title">{t('confirmTitle')}</h2>
      {link ? (
        <button className="primary block" onClick={() => window.location.assign(link)}>
          {t('signIn')}
        </button>
      ) : (
        <>
          <p className="error" role="alert">
            {t('badLink')}
          </p>
          <a className="button block" href="/login">
            {t('signIn')}
          </a>
        </>
      )}
    </div>
  );
}
